<template>
    <div id="app">
        <!-- <router-view></router-view> -->
        <!-- pc端 -->
        <Main v-show="page == 'main'" @handleGift="page = 'gift'"></Main>
        <!-- 移动端 -->
        <Mobile v-show="page == 'mobile'" @handleGift="page = 'gift'"></Mobile>
        <!-- 礼包码 -->
        <Gift v-show="page == 'gift'" @hanldeReturn="hanldeReturn"></Gift>
    </div>
</template>

<script>
import Main from './components/main'
import Mobile from './components/mobile'
import Gift from './components/gift'
import { urls } from '@/tool/url'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    data() {
        return {
            page: 'main',
            screenWidth: document.body.clientWidth
        }
    },
    components: {
        Main,
        Mobile,
        Gift
    },
    watch: {
        screenWidth(val) {
            this.screenWidth = val
            if (this.page == 'gift') {
                return
            }
            if (val < 769) {
                this.page = 'mobile'
            } else {
                this.page = 'main'
            }
        },
        page(val, old) {
            if (val != old) {
                console.log(val)
                document.documentElement.scrollTop = 0
            }
        }
    },
    created() {
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth
                that.screenWidth = window.screenWidth
            })()
        }
        this.init()

        if (parsed.page) {
            if (parsed.page == 'gift') {
                this.page = 'gift'
            }
        }

        if (parsed.downLoad) {
            // window.location.href = urls.ios
            if ((navigator.userAgent.indexOf('iPhone') != -1)) {
                window.location.href = urls.ios
            } else {
                window.location.href = urls.and
            }
        }
    },
    mounted() {
        const that = this
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth
                that.screenWidth = window.screenWidth
            })()
        }
    },
    methods: {
        hanldeReturn() {
            let windowWidth = document.documentElement.clientWidth
            if (windowWidth < 769) {
                this.page = 'mobile'
            } else {
                this.page = 'main'
            }
        },
        init() {
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
            document.addEventListener('gesturestart', function (event) {
                event.preventDefault()
            })
            let windowWidth = document.documentElement.clientWidth
            if (windowWidth < 769) {
                this.page = 'mobile'
            }
            let that = this
            ;(function (doc, win) {
                var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth
                        var clientHeight = docEl.clientHeight

                        if (!clientWidth) return
                        if (clientWidth < 769) {
                            this.page = 'mobile'
                            docEl.style.fontSize = 16 * (clientWidth / 768) + 'px'
                            //     // if (clientWidth > 1023) {
                            //     //     docEl.style.fontSize = '18px'
                            //     // }
                        } else {
                            docEl.style.fontSize = 16 * (clientWidth / 2560) + 'px'
                        }
                    }
                if (!doc.addEventListener) return
                win.addEventListener(resizeEvt, recalc, false)
                doc.addEventListener('DOMContentLoaded', recalc, false)
            })(document, window)
        }
    }
}
</script>

<style>
html,
body {
    min-height: 100%;
    text-align: center;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
}

a {
    text-decoration: none;
    color: #232323;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue